import firebase from "firebase/app";
var db = firebase.firestore();
var batch = db.batch();
var profileRef = db.collection('contact')
export default {
    add: function (contact) {
        // ADDS NEW CONTACT
        if (contact.profile_uid) {
            // If contact_uid exists will save it using it as document id
            return profileRef.doc(contact_uid).set(contact);
        } else {
            // if no id exists will create one and return document id
            return profileRef.add(
                contact
            ).then((docRef) => {
                return docRef.id;
            });
        }
    },
    set: () => this.add(contact), // add or set does the same thing
    update: function (contact, updateObject) {
        let contact_uid = contact.contact_uid // get contact_uid (aka doc id)
        // To update age and favorite color:
        return profileRef.doc(contact_uid).update(contact)
            .then(() => {
                //console.log("Document successfully updated!");
                return "Contact successfully updated!"
            });
    },
    get: function (contact) {
        // if contact is an object get uid
        let profile_uid = typeof contact == 'object' ? contact.profile_uid : contact;
        return profileRef
            .doc(profile_uid)
            .get()
    },
    getUserProfile(uid) {
        // //console.log('uid', uid)
        // const _this = this;
        // const userDefault = JSON.parse(JSON.stringify(config.userDefault));
        // dbProfiles
        //     .where("uid", "==", uid)
        //     .get()
        //     .then((querySnapshot) => {

        //     })
        //     .catch((error) => {
        //         console.log("Error getting documents: ", error);
        //     });
    },
    batchUpdate: function (arrayOfContacts, updateObject) {

        if (typeof arrayOfContacts != Array) { // checks to make sure array is is provided
            console.log('contacts batchUpdate not an array')
            return; // stop batch update
        }

        arrayOfContacts.forEach(contact => {
            let contact_uid = contact.contact_uid // get contact_uid (aka doc id)
            batch.update(profileRef.doc(contact_uid), updateObject);
        })

        return batch.commit().then(() => {
            return "Contact: Batch Update Successful"
        });
    }
}